// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"SearchInput_Wrapper__KuOUa","Input":"SearchInput_Input__WZ4qY","Icon":"SearchInput_Icon__Lz_Zo"};